import Label from './label'

export type { LabelProps } from './label'

export { Label }
